import DayViewItem from '../schema/DayViewItem';
import getGridPositionFromDayViewItem from '../utils/getGridPositionFromDayViewItem';
import React from 'react';
import { DEFAULT_PIXELS_PER_MINUTE } from '../utils/constants';
import { mergeStyles } from '@uifabric/merge-styles';

const classNames = require('classnames');
const styles = require('./DayViewItemsLayer.scss');

/**
 * Interface for DayViewItemsLayerProps
 */
interface DayViewItemsLayerProps<T> {
    /**
     * Renderers for inDayItemRenderer and allDayItemRenderer
     */
    renderers?: {
        inDayItemRenderer: (
            item: T,
            itemAriaLabelGetter?: (itemInfo: string) => string
        ) => JSX.Element;
        customItemsGrid?: () => JSX.Element;
    };
    /**
     * Day view items
     */
    dayViewItems: DayViewItem<T>[];

    /**
     * Pixel per minute
     */
    pixelPerMin: number;

    /**
     * Getter of aria label which takes info for the item and the item position in the list of items as params and returns an aria label
     */
    getItemAriaLabel?: (itemInfo: string, itemIndex: number) => string;

    /** Custom styles for items layer */
    className?: string;
}

/**
 * Layer responsible for rendering day view items
 * @param props
 */
export default function DayViewItemsLayer<T>(props: DayViewItemsLayerProps<T>) {
    const {
        dayViewItems,
        renderers: { inDayItemRenderer, customItemsGrid } = {
            inDayItemRenderer: undefined,
            customItemsGrid: undefined,
        },
        pixelPerMin = DEFAULT_PIXELS_PER_MINUTE,
        getItemAriaLabel,
        className: customClassNames,
    } = props;

    return (
        <div className={classNames(styles.dayViewItemsLayer, customClassNames)}>
            {customItemsGrid
                ? customItemsGrid()
                : !!dayViewItems &&
                  dayViewItems.map((item, index) => {
                      const key: string = 'dayViewItem_' + index;
                      const { top, height, left, width } = getGridPositionFromDayViewItem(
                          item,
                          pixelPerMin
                      );
                      const dayItemPosition = mergeStyles({
                          top: top,
                          left: left,
                          height: height,
                          width: width,
                      });
                      return (
                          <div
                              key={key}
                              className={classNames(styles.dayItemContainer, dayItemPosition)}>
                              {inDayItemRenderer ? (
                                  inDayItemRenderer(item.event, (itemInfo: string) =>
                                      getItemAriaLabel
                                          ? getItemAriaLabel(itemInfo, index)
                                          : itemInfo
                                  )
                              ) : (
                                  // Remove it later
                                  <div className={styles.defaultDayItem}>
                                      <div className={styles.defaultDayItemContent}>
                                          {'Event title'}
                                      </div>
                                  </div>
                              )}
                          </div>
                      );
                  })}
        </div>
    );
}
